import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    _createVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4 15.993V19a1 1 0 001 1h14a1 1 0 001-1v-3.007M19.352 11.436l-3.047 3.198-3.048-3.198"
    }),
    _createVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.4 13.958V8.952A4.952 4.952 0 0111.352 4v0a4.952 4.952 0 014.953 4.952v5.006"
    })
  ]))
}